// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__2GCdt","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__1KAJo"};